import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { Qualification } from '../../../shared/models/control-points/qualification.model';
import { QualificationService } from '../../../shared/services/control-points/qualification.service';

@Component({
  selector: 'app-qualifications-page',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    CardModule,
    TableModule,
    ButtonModule,
    ToastModule,
    ConfirmDialogModule,
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './qualifications-page.component.html',
  styleUrl: './qualifications-page.component.scss',
})
export class QualificationsPageComponent implements OnInit {
  service = inject(QualificationService);
  #messageService = inject(MessageService);
  #confirmationService = inject(ConfirmationService);
  #translate = inject(TranslateService);
  #router = inject(Router);

  ngOnInit(): void {
    this.service.getAll();
  }

  navigateToCreate() {
    this.#router.navigate(['/control-points/qualifications/new']);
  }

  navigateToDetail(item: Qualification) {
    this.#router.navigate(['/control-points/qualifications', item.id]);
  }

  trainerCount(item: Qualification): number {
    return Array.isArray(item.users) ? item.users.length : 0;
  }

  onRowDelete(event: Event, item: Qualification) {
    this.#confirmationService.confirm({
      target: event.target as EventTarget,
      header: this.#translate.instant(
        'controlPoints.qualifications.deleteConfirmHeader',
      ),
      message: this.#translate.instant(
        'controlPoints.qualifications.deleteConfirmMessage',
      ),
      acceptLabel: this.#translate.instant('label.delete'),
      rejectLabel: this.#translate.instant('label.cancel'),
      acceptButtonProps: { severity: 'danger' },
      accept: () => {
        this.service.delete(item.id).subscribe({
          next: () => {
            this.service.getAll();
            this.#messageService.add({
              severity: 'success',
              summary: this.#translate.instant('label.successHeader'),
              detail: this.#translate.instant(
                'controlPoints.qualifications.deleted',
              ),
            });
          },
          error: () => {
            this.#messageService.add({
              severity: 'error',
              summary: this.#translate.instant('label.errorHeader'),
              detail: this.#translate.instant(
                'controlPoints.qualifications.deleteError',
              ),
            });
          },
        });
      },
    });
  }
}
